var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"patient-forgot-page"},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('h2',[_vm._v("Patient Forgot Password")])])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('p',[_vm._v(_vm._s(_vm.message))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47408998","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/patient/patient-forgot-password.vue
// module id = fkJA
// module chunks = 1